<template>
  <div class="page whatsapp-templates">
    <div class="row">
      <div class="col-12">
        <h2>WhatsApp Templates</h2>
        <h5 class="mt-4">How to chat to guests: 2 scenarios</h5>
        <ol>
          <li>If a <b>guest messages you</b> - you can respond freely for 24 hours</li>
          <li>If <b>you</b> want to reach out to the <b>guest first</b> - you need to <b>create a template</b> and then <b>submit it for WhatsApp approval</b>.<br>Once the template is approved, you can use it in an <b>automation</b>.</li>
        </ol> 
        <h5 class="mt-4">Conversations with Guests</h5>
        <ul>
          <li>
            WhatsApp defines a <strong>conversation</strong> as a 24-hour message thread between you and a guest.
          </li>
          <li>
            You will either be <strong>starting a conversation</strong>
            with a guest, or <strong>replying</strong> to a guest.
          </li>
          <li>
            You <strong>don't need to submit</strong> a template for approval if you will <strong>only</strong> use it to <strong>reply</strong> to a guest.
          </li>
        </ul>
      </div>
    </div>

    <div class="whatsapp-templates__list">
      <div class="header">
        <div class="header__name">Name</div>
        <div class="header__category">Usage</div>
        <div class="header__language">Language</div>
        <div class="header__status">Status</div>
        <div class="header__last-updated">Last Updated</div>
        <div class="header__actions"></div>
      </div>
      <div class="template" v-for="(template) of whatsAppTemplates" v-bind:key="template.reference" v-on:click.stop="editTemplate(template)">
        <div class="template__name">{{template.name}}</div>
        <div class="template__category">{{convertCategoryToUsage(template.category)}}</div>
        <div class="template__language">{{getLanguageNameFromCode(template.language)}}</div>
        <div class="template__status"
             v-bind:class="{
                'template__status--approved' : isTemplateApproved(template),
                'template__status--under-review' : isTemplateUnsubmitted(template) || isTemplateReceived(template) || isTemplatePending(template) ,
                'template__status--rejected' : isTemplateRejected(template) || isTemplatePaused(template) || isTemplateDisabled(template)}"
             v-html="templateStatusForDisplay(template)">
        </div>
        <div class="template__last-updated">{{friendlyDate(template.lastUpdated)}}</div>
        <div class="template__actions">
          <i class="fas fa-ellipsis-h"></i>
<!--          <div v-if="isShowMenu(index)" class="">-->
<!--            <ul>-->
<!--              <li v-on:click.stop="previewVariable(variable)"><span><i class="fas fa-eye"></i></span> Preview</li>-->
<!--              <li v-if="!variable.systemVariable" v-on:click.stop="editVariable(variable)"><span><i class="fas fa-edit"></i></span> Edit</li>-->
<!--              <li v-if="!variable.systemVariable" v-on:click.stop="confirmDeleteVariable(variable)"><span><i class="fas fa-trash-alt"></i></span> Delete</li>-->
<!--            </ul>-->
<!--          </div>-->
        </div>
      </div>
      <div v-if="whatsAppTemplates.length === 0" class="whatsapp-templates__list__no-templates">
        You haven't created any WhatsAppTemplates yet
      </div>
      <div v-if="!isWhatsAppActive" class="whatsapp-templates__list__no-templates">
        <span>Please activate WhatsApp. Go to <router-link to="/list-establishments">Configure Establishments</router-link> and click on WhatsApp.</span>
      </div>
    </div>

    <div v-if="isWhatsAppActive" class="row mt-3 mb-3">
      <div class="col-12 text-right">
        <button v-on:click.stop="addTemplate" class="btn btn-primary">Create a Template</button>
      </div>
    </div>

    <edit-template v-if="showEditTemplateDialog" v-bind:template="selectedTemplate"></edit-template>
    <submit-template v-if="showSubmitTemplateDialog" v-bind:template="selectedTemplate"></submit-template>
  </div>
</template>

<script>
    import { store } from '../store.js'
    // import Spinner from '../components/Spinner.vue'

    import EditTemplate from '../components/whatsapp/EditTemplate'
    import SubmitTemplate from '../components/whatsapp/SubmitTemplate'

    import {datesMixin} from "../mixins/DatesMixin"
    import {languagesMixin} from '../mixins/LanguagesMixin'
    import {whatsAppMixin} from "../mixins/WhatsAppMixin"
    import {whatsAppTemplateMixin} from "../mixins/WhatsAppTemplateMixin"
    import {whatsAppTemplatesMixin} from "../mixins/WhatsAppTemplatesMixin"

    export default {
        name: 'WhatsAppTemplates',
        components: { EditTemplate, SubmitTemplate },
        mixins: [datesMixin, languagesMixin, whatsAppMixin, whatsAppTemplateMixin, whatsAppTemplatesMixin],
        data: function () {
            return {
                selectedTemplate: null,
                showEditTemplateDialog: false,
                showSubmitTemplateDialog: false
            }
        },
        computed: {
        },
        methods: {
            convertCategoryToUsage: function (category) {
                switch (category) {
                    case "utility":
                        return "Start conversation & Reply";
                    case "marketing":
                        return "Marketing";
                    default:
                        return "Reply only";
                }
            },
            addTemplate: function() {
                console.log("Adding a Template");
                this.selectedTemplate = {name: "", category: "utility", language: "en", contentType: "text", content: "", status: "under-review", lastUpdated: null, sampleVariables: []};
                this.showEditTemplateDialog = true;
            },
            editTemplate: function (template) {
                console.log("Editing: " + template.reference);
                this.selectedTemplate = template;
                this.showEditTemplateDialog = true;
            },
            stopEditingTemplate(editedTemplate) {
                this.selectedTemplate = null;
                this.showEditTemplateDialog = false;
                if (editedTemplate) {
                    for (let existing of this.whatsAppTemplates) {
                        if (existing.reference === editedTemplate.reference) {
                            Object.assign(existing, editedTemplate);
                            return
                        }
                    }
                    this.whatsAppTemplates.push(editedTemplate);
                }
            },
            startSubmitTemplate: function (template) {
                console.log("Showing submit dialog: " + template.reference);
                this.selectedTemplate = template;
                this.showEditTemplateDialog = false;
                this.showSubmitTemplateDialog = true;
            },
            stopSubmitTemplate(template) {
                this.selectedTemplate = null;
                this.showSubmitTemplateDialog = false;
                if (template) {
                    for (let existing of this.whatsAppTemplates) {
                        if (existing.reference === template.reference) {
                            Object.assign(existing, template);
                        }
                    }
                }
            },
            loadInitialData: async function() {
                console.log("Loading WhatsApp Templates");
                await this.fetchWhatsApp(store.currentEstablishmentReference);
                this.fetchWhatsAppTemplates();
            },
        },
        mounted: async function() {
            await this.loadInitialData();
            this.$root.$on("finished-editing-template", this.stopEditingTemplate);
            this.$root.$on("start-submitting-template", this.startSubmitTemplate);
            this.$root.$on("finished-submitting-template", this.stopSubmitTemplate);
            this.$root.$on('selected-establishment', this.loadInitialData);
        }, beforeDestroy() {
            this.$root.$off("finished-editing-template", this.stopEditingTemplate);
            this.$root.$off("start-submitting-template", this.startSubmitTemplate);
            this.$root.$off("finished-submitting-template", this.stopSubmitTemplate);
            this.$root.$off('selected-establishment', this.loadInitialData);
        }
    }
</script>

<style lang="scss" scoped>
  @import "../styles/pages/whatsapp-templates";
</style>
